import { z } from '@hono/zod-openapi'

export const zRestAuthSelectUser = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    defaultMembershipId: z.string().nullable(),
    lastLogin: z.coerce.date().nullable(),
    bannedAt: z.coerce.date().nullable(),
    verifiedAt: z.coerce.date().nullable(),
    projectId: z.string(),
    createdAt: z.coerce.date().nullable(),
    updatedAt: z.coerce.date().nullable(),
})

export const zRestAuthGroupConfig = z.object({
    id: z.string(),
    label: z.string(),
    type: z.string(),
    defaultRoleId: z.string(),
    defaultOrganizationId: z.string().optional(),
})

export const zRestAuthGroupConfigResponse = z.object({
    groups: zRestAuthGroupConfig.array(),
})

export type RestAuthSelectUser = z.infer<typeof zRestAuthSelectUser>
export type RestAuthGroupConfig = z.infer<typeof zRestAuthGroupConfig>
export type RestAuthGroupConfigResponse = z.infer<
    typeof zRestAuthGroupConfigResponse
>

export type RestAuthGroup<T extends GroupType> = {
    id: string
    label: string
    type: T
    defaultRoleId: string
    defaultOrganizationId?: string
}

export type GroupType = (typeof GroupType)[keyof typeof GroupType]

export const GroupType = {
    vendor: 'vendor',
    client: 'client',
    superAdmin: 'superAdmin',
} as const
